
import { defineComponent } from "vue";
import CustomTextInput from "../components/inputs/CustomTextInput.vue";
import CheckmarkIcon from "../components/icons/CheckmarkIcon.vue";
import WarningIcon from "../components/icons/WarningIcon.vue";

const CHECK_LOGIN_PATH = "/api/v1/login_required";

export default defineComponent({
  name: "Login",
  components: {
    CustomTextInput,
    CheckmarkIcon,
    WarningIcon,
  },
  data() {
    return {
      focusPasswordInput: false,
    };
  },
  methods: {
    tc(key: string): string {
      return this.$t("login." + key);
    },
    setSettingFunction(name: string): (value: string) => void {
      return (value: string) => {
        this.$store.commit("setSetting", { name, value });
        this.$store.commit("setLoginStatus", null);
      };
    },
    tryLogin() {
      const { username, password } = this.$store.state.settings;
      if (!password) {
        //this.$refs.passwordInput.focusInput();
        // focus password input by changing prop value :(
        this.focusPasswordInput = true;
        this.$nextTick(() => (this.focusPasswordInput = false));
        return;
      }
      fetch(`${this.$store.state.settings.submitHost}${CHECK_LOGIN_PATH}`, {
        method: "GET",
        credentials: "include",
        headers: {
          Authorization: "Basic " + btoa(username + ":" + password),
        },
      })
        .then(async (response) => {
          let text = await response.text();
          if (response.status === 200 && text === "ok") {
            this.$store.commit("setLoginStatus", true);
          } else {
            throw text;
          }
        })
        .catch((error) => {
          console.log({ msg: "failed", response: error.toString() });
          this.$store.commit("setLoginStatus", false);
        });
    },
  },
});
